// Alternative mock data for bold agency style

export const portfolioProjectsAlt = [
  {
    id: '1',
    title: 'SMILE BRIGHT',
    subtitle: 'Dental Excellence',
    category: 'Healthcare',
    client: 'SmileBright Dental Clinic',
    description: 'Transforming dental care through cinematic storytelling.',
    videoUrl: 'https://player.vimeo.com/video/76979871?autoplay=1&loop=1&muted=1',
    thumbnailUrl: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=1200&q=80',
    color: '#FF4500',
    services: ['Brand Film', 'Patient Stories', 'Social Content'],
    duration: '2:30',
    year: '2024',
    impact: '+45% bookings',
    challenge: 'Create emotional connection in healthcare marketing',
    solution: 'Authentic patient stories with cinematic production values',
    results: '45% increase in consultations, 3x social engagement'
  },
  {
    id: '2',
    title: 'ELEVATION',
    subtitle: 'Luxury Real Estate',
    category: 'Real Estate',
    client: 'Elevation Realty Group',
    description: 'Selling lifestyle, not just homes.',
    videoUrl: 'https://player.vimeo.com/video/162339719?autoplay=1&loop=1&muted=1',
    thumbnailUrl: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80',
    color: '#0066FF',
    services: ['Property Tours', 'Drone Cinematography', 'Agent Branding'],
    duration: '3:15',
    year: '2024',
    impact: '60% faster sales',
    challenge: 'Stand out in saturated luxury market',
    solution: 'Lifestyle-focused aerial cinematography',
    results: '60% faster sales, premium pricing maintained'
  },
  {
    id: '3',
    title: 'MODERN MIND',
    subtitle: 'Podcast Production',
    category: 'Podcast',
    client: 'The Modern Mind',
    description: 'Multi-camera conversations that captivate.',
    videoUrl: 'https://player.vimeo.com/video/336812660?autoplay=1&loop=1&muted=1',
    thumbnailUrl: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=1200&q=80',
    color: '#00FF88',
    services: ['Podcast Video', 'Multi-Cam', 'Motion Graphics'],
    duration: '45:00',
    year: '2024',
    impact: '200K+ views',
    challenge: 'Transform audio into visual experience',
    solution: 'Dynamic multi-angle shooting with strategic B-roll',
    results: '200K+ views per episode, 85% retention'
  },
  {
    id: '4',
    title: 'SPINE & WELLNESS',
    subtitle: 'Chiropractic Care',
    category: 'Healthcare',
    client: 'Spine & Wellness Center',
    description: 'Educational content that builds trust.',
    videoUrl: 'https://player.vimeo.com/video/291493454?autoplay=1&loop=1&muted=1',
    thumbnailUrl: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&q=80',
    color: '#FF00FF',
    services: ['Educational Videos', 'Treatment Showcase', 'Testimonials'],
    duration: '1:45',
    year: '2024',
    impact: '+90% inquiries',
    challenge: 'Demystify chiropractic care',
    solution: 'Documentary-style patient journey series',
    results: '90% increase in new patients'
  },
  {
    id: '5',
    title: 'URBAN LIVING',
    subtitle: 'City Culture Show',
    category: 'Podcast',
    client: 'Urban Living Show',
    description: 'High-energy podcast covering city life.',
    videoUrl: 'https://player.vimeo.com/video/395335022?autoplay=1&loop=1&muted=1',
    thumbnailUrl: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1200&q=80',
    color: '#FFD700',
    services: ['Studio Setup', 'Live Streaming', 'Highlight Reels'],
    duration: '60:00',
    year: '2023',
    impact: '-40% production time',
    challenge: 'Broadcast quality on lean budget',
    solution: 'Versatile studio with efficient workflows',
    results: '40% faster production, premium quality maintained'
  },
  {
    id: '6',
    title: 'PRESTIGE',
    subtitle: 'Estate Showcase',
    category: 'Real Estate',
    client: 'Prestige Realty',
    description: 'Cinematic tours of million-dollar estates.',
    videoUrl: 'https://player.vimeo.com/video/322879817?autoplay=1&loop=1&muted=1',
    thumbnailUrl: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1200&q=80',
    color: '#00FFFF',
    services: ['Luxury Films', 'Aerial Cinema', '3D Virtual Tours'],
    duration: '4:00',
    year: '2023',
    impact: '+120% int. buyers',
    challenge: 'Attract international luxury buyers',
    solution: 'Mini-documentary style architectural films',
    results: '120% increase in international interest'
  }
];

export const heroContentAlt = {
  headline: 'FILMMAKING',
  subheadline: 'THAT SELLS',
  description: 'Commercial video production for businesses that demand results',
  stats: [
    { number: '200+', label: 'Projects' },
    { number: '50+', label: 'Clients' },
    { number: '10', label: 'Years' },
    { number: '2M+', label: 'Views' }
  ]
};